module.exports = __webpack_public_path__ + "static/media/nav-subtraction.990050c9.svg";